import * as Service from '@/App/Service';
import ChalkySticks from '@chalkysticks/sdk';
import Router from '@/Router';
import Store from '@/Store';

/**
 * Whether auth manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize authentication event listeners.
 *
 * @return void
 */
export function initialize(): void {
	if (hasInitialized) {
		return;
	}

	ChalkySticks.Core.Event.Bus.on('logout:request', () => {
		Router.push({ name: 'PageLogout' });
	});

	// Re-register push token on login to associate with user account
	ChalkySticks.Core.Event.Bus.on('authentication:login', () => {
		Service.PushNotification.refreshRegistration();
	});

	// Unregister push token on logout to disassociate from user
	ChalkySticks.Core.Event.Bus.on('authentication:logout', () => {
		Service.PushNotification.unregister();
	});

	// Check for web-based OAuth token in URL (e.g. Google redirect)
	authenticateByToken();

	hasInitialized = true;
}

/**
 * Check for a URL token from an OAuth redirect (e.g. Google) and
 * authenticate with it. This is only used in web-based OAuth flows,
 * not in the native app.
 *
 * @return Promise<void>
 */
async function authenticateByToken(): Promise<void> {
	const authModel = Store.getters['authentication/authModel'];
	let token: string;

	// See if we have a token in our URL
	if ((token = ChalkySticks.Model.Authentication.getAuthToken())) {
		authModel.loginWithToken(token).then((userModel: ChalkySticks.Model.User) => {
			ChalkySticks.Utility.Log.info('app', 'User:', userModel.getName(), userModel);
		});
	}
}
